var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkipBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 15.8327V4.16602M13.6674 5.06569L8.80177 8.95819C8.3569 9.31409 8.13447 9.49204 8.05393 9.70702C7.98332 9.89551 7.98332 10.1032 8.05393 10.2917C8.13447 10.5067 8.3569 10.6846 8.80177 11.0405L13.6674 14.933C14.3609 15.4878 14.7076 15.7652 14.9994 15.7655C15.2532 15.7658 15.4933 15.6504 15.6516 15.452C15.8337 15.224 15.8337 14.7799 15.8337 13.8918V6.10685C15.8337 5.21877 15.8337 4.77472 15.6516 4.54666C15.4933 4.34832 15.2532 4.23293 14.9994 4.2332C14.7076 4.23352 14.3609 4.51091 13.6674 5.06569Z",
    stroke: "#424242",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipBack);
export default __webpack_public_path__ + "static/media/skip-back.02d13f51fa0638c58ae17b6abdd1cf19.svg";
export { ForwardRef as ReactComponent };